import beforeLiveCover from "../assets/Books-covers-and-pdf/before_i_learned_to_live.webp";
import minorShiftCover from "../assets/Books-covers-and-pdf/the_power_of_minor_shift.webp";
import survivingAgeCover from "../assets/Books-covers-and-pdf/the_surviving_age.webp";
import twoBagsCover from "../assets/Books-covers-and-pdf/two_bags_no_plan.webp";

import urduCover1 from "../assets/Books-cover-urdu/rakh_se_ghulab.webp";
import urduCover2 from "../assets/Books-cover-urdu/choti_tabdeeli.webp";
import urduCover3 from "../assets/Books-cover-urdu/zinda_rehne_ka_hunar.webp";

const defaultBooks = {
    1: {
        id: 1,
        title: "Before I Learned to Live",
        author: "Dolat Khan Kakar",
        category: "Memoir / Personal Growth",
        type: "pdf",
        cover: beforeLiveCover,
        pdf: null,
        readerPages: 312,
        rating: 4.7,
        reviews: 1247,
        description: "A reflective journey through struggle, self-discovery, and the lessons that arrive before a person truly learns how to live with intention.",
        pages: 312,
        language: "English",
        isbn: "978-969-XXXXX-1",
        publisher: "Kitabon Ki Dolat Publishing",
        published: "2025",
        ebookPrice: 899,
        printPrice: 1299
    },
    2: {
        id: 2,
        title: "The Power of Minor Shift",
        author: "Dolat Khan Kakar",
        category: "Self-Help / Mindset",
        type: "pdf",
        cover: minorShiftCover,
        pdf: null,
        readerPages: 338,
        rating: 4.8,
        reviews: 892,
        description: "Small changes can reshape a whole life. This book explores the practical mental shifts that turn ordinary decisions into lasting growth.",
        pages: 338,
        language: "English",
        isbn: "978-969-XXXXX-2",
        publisher: "Kitabon Ki Dolat Publishing",
        published: "2026",
        ebookPrice: 1199,
        printPrice: 1599
    },
    3: {
        id: 3,
        title: "The Surviving Age",
        author: "Dolat Khan Kakar",
        category: "Society / Resilience",
        type: "pdf",
        cover: survivingAgeCover,
        pdf: null,
        readerPages: 192,
        rating: 4.3,
        reviews: 2156,
        description: "A clear-eyed look at pressure, survival, and the emotional cost of modern life, written for readers trying to stay whole in difficult times.",
        pages: 192,
        language: "English",
        isbn: "978-969-XXXXX-3",
        publisher: "Kitabon Ki Dolat Publishing",
        published: "2025",
        ebookPrice: 699,
        printPrice: 999
    },
    4: {
        id: 4,
        title: "Two Bags No Plan",
        author: "Dolat Khan Kakar",
        category: "Travel / Adventure",
        type: "pdf",
        cover: twoBagsCover,
        pdf: null,
        readerPages: 264,
        rating: 4.6,
        reviews: 634,
        description: "A restless, human travel story about leaving with little certainty and discovering what movement, discomfort, and surprise can teach.",
        pages: 264,
        language: "English",
        isbn: "978-969-XXXXX-4",
        publisher: "Kitabon Ki Dolat Publishing",
        published: "2026",
        ebookPrice: 1399,
        printPrice: 1799
    },
    5: {
        id: 5,
        title: "Rakh Se Ghulab",
        author: "Dolat Khan Kakar",
        category: "Society / Insight",
        type: "pdf",
        cover: urduCover1,
        pdf: null,
        readerPages: 200,
        rating: 4.4,
        reviews: 320,
        description: "An insightful perspective on societal changes and enduring truths, presented in Urdu.",
        pages: 200,
        language: "Urdu",
        isbn: "978-969-XXXXX-5",
        publisher: "Kitabon Ki Dolat Publishing",
        published: "2026",
        ebookPrice: 800,
        printPrice: 1200
    },
    6: {
        id: 6,
        title: "Choti Tabdeeli Ki Bardi Taqat",
        author: "Dolat Khan Kakar",
        category: "Self-Help / Reflection",
        type: "pdf",
        cover: urduCover2,
        pdf: null,
        readerPages: 250,
        rating: 4.9,
        reviews: 450,
        description: "A deep dive into personal growth and reflection, tailored for the Urdu readership.",
        pages: 250,
        language: "Urdu",
        isbn: "978-969-XXXXX-6",
        publisher: "Kitabon Ki Dolat Publishing",
        published: "2026",
        ebookPrice: 900,
        printPrice: 1300
    },
    7: {
        id: 7,
        title: "Zinda Rehne Ka Hunar",
        author: "Dolat Khan Kakar",
        category: "Memoir / Personal Growth",
        type: "pdf",
        cover: urduCover3,
        pdf: null,
        readerPages: 312,
        rating: 4.5,
        reviews: 1500,
        description: "A reflective journey through struggle, self-discovery, and the lessons that arrive before a person truly learns how to live with intention (Urdu Edition).",
        pages: 312,
        language: "Urdu",
        isbn: "978-969-XXXXX-7",
        publisher: "Kitabon Ki Dolat Publishing",
        published: "2025",
        ebookPrice: 899,
        printPrice: 1299
    }
};

const isBrowser = typeof window !== 'undefined';

function getStoredBooks() {
    if (!isBrowser) return defaultBooks;
    try {
        const local = localStorage.getItem('kitabon_books');
        const parsed = local ? JSON.parse(local) : {};
        const merged = Object.fromEntries(
            Object.entries(defaultBooks).map(([id, book]) => [
                id,
                { ...(parsed[id] || {}), ...book }
            ])
        );
        if (!local) {
            localStorage.setItem('kitabon_books', JSON.stringify(defaultBooks));
        }
        return merged;
    } catch (e) {
        return defaultBooks;
    }
}

export const books = new Proxy({}, {
    get(target, prop) {
        return getStoredBooks()[prop];
    },
    ownKeys() {
        return Reflect.ownKeys(getStoredBooks());
    },
    getOwnPropertyDescriptor() {
        return {
            enumerable: true,
            configurable: true
        };
    }
});
